import { Entity } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { SendAllAssetsTo } from '~/components/send-all-assets-to/SendAllAssetsTo';

import { useCompetitorsData } from '../../hooks/useCompetitorsData';
import { CompetitorsTable } from './competitors-table/CompetitorsTable';
import styles from './CompetitorsTab.module.scss';

interface CompetitorsTabProps {
  entity: Entity;
}

export const CompetitorsTab = ({ entity }: CompetitorsTabProps) => {
  const { t } = useTranslation(['widget']);

  const { tableData, columnsMeta, isError, isFetching } = useCompetitorsData({
    entityTag: entity.tag,
  });

  const displayedEntityTags = tableData
    .filter(row => row.hasData)
    .map(row => row.entity?.tag) as string[];

  return (
    <ErrorBoundaryWrapper>
      {!!displayedEntityTags.length && (
        <div className={styles.menuBar}>
          <div className={styles.assetsCounter}>
            {t(
              'widget:assetOverview.knowledgeGraph.competitors.assetsCounter',
              {
                count: displayedEntityTags.length,
              }
            )}
          </div>
          <SendAllAssetsTo
            entityTags={displayedEntityTags}
            source="asset_overview"
          />
        </div>
      )}
      <div className={styles.scrollContainer}>
        <CompetitorsTable
          tableData={tableData}
          columnsMeta={columnsMeta}
          isError={isError}
          isFetching={isFetching}
        />
      </div>
    </ErrorBoundaryWrapper>
  );
};
